export default __webpack_public_path__ + "static/media/maure_de_bretagne5.90ef182b.jpg";